import { useContext } from "react";
import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import ReTableView from "../../Dashboard/common/ReTableView";
import { transformDataForMultibarChart } from "../../../utils/helpers";
import { filterUniqueDomains } from "./Sources";
import { tab } from "../BrandScore/BrandScore";
import Checkbox from "@mui/material/Checkbox";

const SourcesOverview = () => {
  const discoveryCtx = useContext(DiscoveryContext);
  const selectedLLM = [discoveryCtx.state.selectedLLM];
  const selectedCategory = [discoveryCtx.state.selectedCategory];
  const selectedMarket = [discoveryCtx.state.selectdMarket];
  const sources = discoveryCtx?.sources ?? [];
  // formatted sources data for chart
  let data = formatDomainData(selectedLLM, sources, selectedCategory,selectedMarket, "count");
  let sourceAlias = formatDomainData(selectedLLM, sources, selectedCategory,selectedMarket, "urls");
  data = transformDataForMultibarChart(data, true);
  const id = "Sources_Overview";
  const { checked, uniqueKey } = useIsSelectedSection({ id });

  return (
    <>
      <br />
      <div className="Heading-checkbox">
        <h5>Sources Overview</h5>

        {discoveryCtx.state.showReportCheckbox && (
          <Checkbox
            checked={checked}
            onChange={() => {
              discoveryCtx?.clickComponentCheckbox({
                uniqueKey,
                filter: {
                  id: id,
                  title: "Sources Overview",
                  tab: tab.brandOverview,
                  uniqueKey,
                },
                checked,
                id,
              });
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        )}
      </div>
      <hr />
      <div id={id}>
        <ReTableView
        type="Brand"
        data={data}
        sourceAlias={sourceAlias}
        renderValidate={false}
      />
      </div>
    </>
  );
};

export default SourcesOverview;

export function formatDomainData(mapArr, data, filterArr, market, mode = "count") {
  let formatted = {};

  mapArr.forEach((key) => {
    if (!data[key]) return;
    let propertyArr = Object.entries(data[key]);
    if (!propertyArr.length) return;

    propertyArr.forEach(([name, obj]) => {
      if (!filterArr.includes(name)) return;

      let marketUrls = obj?.[market] || [];

      let domains = filterUniqueDomains(marketUrls);

      let reduceObj = domains.reduce((acc, d) => {
        if (mode === "count") {
          acc[d.src] = d?.urls?.length ?? 0;
        } else if (mode === "urls") {
          acc[d.src] = (d?.urls ?? []).map((url) => ({
            url,
            http_status: "200", // hardcoded
          }));
        }
        return acc;
      }, {});

      if (mode === "count") {
        // keep LLM key wrapper
        formatted[key] = { ...formatted[key], ...reduceObj };
      } else {
        // flatten (no LLM key)
        formatted = { ...formatted, ...reduceObj };
      }
    });
  });

  return formatted;
}

// export function formatDomainData(mapArr, data, filterArr,market, mode = "count") {
//   let formatted = {};

//   mapArr.forEach((key) => {
//     if (!data[key]) return;
//     let propertyArr = Object.entries(data[key]);
//     if (!propertyArr.length) return;
//     console.log("formatDomainData",data,key,propertyArr,filterArr,market)

//     propertyArr.forEach(([name, obj]) => {
//       if (!filterArr.includes(name)) return;

//       let domains = filterUniqueDomains(obj);

//       let reduceObj = domains.reduce((acc, d) => {
//         if (mode === "count") {
//           acc[d.src] = d?.urls?.length ?? 0;
//         } else if (mode === "urls") {
//           acc[d.src] = (d?.urls ?? []).map((url) => ({
//             url,
//             http_status: "200", // hardcoded
//           }));
//         }
//         return acc;
//       }, {});

//       if (mode === "count") {
//         // keep LLM key wrapper
//         formatted[key] = { ...formatted[key], ...reduceObj };
//       } else {
//         // flatten (no LLM key)
//         formatted = { ...formatted, ...reduceObj };
//       }
//     });
//   });

//   return formatted;
// }

